import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { View } from 'foundations-components/transitional/components/View';
import { useState } from 'react';
import { KeyTypes } from '../../constants/popover';
import { isValidAnchorId } from '../../utils/anchor';
import { isWhitespace } from '../../utils/url';
import ExplicitSaveControls from '../ExplicitSaveControls';
import { AnchorInputField, HowToUseAnchorsTooltip } from './sharedComponents';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.anchor.${suffix}`;
function AnchorPopoverBodyControls({
  popoverType,
  anchorId: initialAnchorId = '',
  anchorList,
  onSubmit,
  onClose
}) {
  const [anchorId, setAnchorId] = useState(initialAnchorId);
  const [isInvalidAnchorId, setIsInvalidAnchorId] = useState(false);
  const canSubmit = !isWhitespace(anchorId) && !isInvalidAnchorId && anchorId !== initialAnchorId;
  const handleAnchorIdChange = evt => {
    const {
      value
    } = evt.target;
    setAnchorId(value);
    setIsInvalidAnchorId(!isValidAnchorId(value));
  };
  const handleSubmit = () => {
    if (anchorList.includes(anchorId)) {
      setIsInvalidAnchorId('duplicate');
    } else {
      onSubmit(anchorId);
    }
  };
  const handleKeyDown = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      onClose();
    } else if (evt.key === KeyTypes.ENTER && canSubmit) {
      handleSubmit();
      evt.preventDefault();
    }
  };
  return /*#__PURE__*/_jsx("div", {
    onKeyDown: handleKeyDown,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "294px",
      children: /*#__PURE__*/_jsxs(Fieldset, {
        "data-test-id": "anchor-popover-body-controls",
        padding: "500",
        _size: "small",
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`${popoverType}Title`)
          })
        }), /*#__PURE__*/_jsx(AnchorInputField, {
          i18nKey: i18nKey,
          anchorId: anchorId,
          invalidAnchorId: isInvalidAnchorId,
          onChange: handleAnchorIdChange
        }), /*#__PURE__*/_jsx(HowToUseAnchorsTooltip, {
          i18nKey: i18nKey
        }), /*#__PURE__*/_jsx(ExplicitSaveControls, {
          paddingBlockStart: "400",
          popoverType: popoverType,
          isSubmitDisabled: !canSubmit,
          onSubmit: handleSubmit,
          onCancel: onClose
        })]
      })
    })
  });
}
AnchorPopoverBodyControls.displayName = 'AnchorPopoverBodyControls';
export default AnchorPopoverBodyControls;